import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./output.css";

const App = () => {
  const [city, setCity] = useState("");
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(false);

  const API_KEY = "c3e27f51690d3076c72f11fbb323c341";

  const fetchWeather = async () => {
    if (!city) return;

    setLoading(true);
    setWeather(null);

    try {
      const res = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API_KEY}&units=metric`
      );

      if (!res.ok) {
        throw new Error("City not found");
      }

      const data = await res.json();
      setWeather(data);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const markerIcon = new L.Icon({
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });

  return (
    <div className="min-h-screen bg-blue-50 flex flex-col items-center justify-center font-sans p-4">
      <h1 className="text-2xl font-bold mb-6">Weather App 🌤</h1>

      <div className="flex gap-2 mb-4">
        <input
          type="text"
          placeholder="Enter city"
          className="border px-4 py-2 rounded"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
        <button
          onClick={fetchWeather}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Search
        </button>
      </div>

      {loading && <p>Loading...</p>}

      {weather && (
        <div className="w-full flex flex-col items-center gap-6">
          <div className="bg-white shadow-md rounded p-6 w-80 text-center">
            <h2 className="text-xl font-semibold mb-2">{weather.name}</h2>
            <p className="text-4xl font-bold">{weather.main.temp}°C</p>
            <p className="capitalize text-gray-600 mt-2">
              {weather.weather[0].description}
            </p>
          </div>

          <MapContainer
            center={[weather.coord.lat, weather.coord.lon]}
            zoom={10}
            scrollWheelZoom={false}
            style={{ height: "300px", width: "90%", maxWidth: "600px" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
            />
            <Marker
              position={[weather.coord.lat, weather.coord.lon]}
              icon={markerIcon}
            >
              <Popup>{weather.name}</Popup>
            </Marker>
          </MapContainer>
        </div>
      )}
    </div>
  );
};

export default App;
